// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nOkK","label":"styles_label__2MnFM"};